// extracted by mini-css-extract-plugin
export default {"page":"SocialClubs_page__CpvGT","container":"SocialClubs_container__xslxA","header":"SocialClubs_header__hqjn6","bar":"SocialClubs_bar__LJKR8","table":"SocialClubs_table__E4fA9"};